import { labeled, boolean, stringRequired, custom } from '../../util/joi';

export const schema = (Joi: any, label: string) =>
  custom(Joi)
    .object()
    .keys({
      accommodateTemporaryReduction: boolean(Joi).label(
        labeled(
          label,
          'Accommodate temporary reduction in income (e.g. parental leave, changing circumstances)'
        )
      ),
      accommodateAnticipated: boolean(Joi).label(
        labeled(
          label,
          'Accommodate anticipated nonrecurring expense item (e.g. education, renovation/construction, furniture)'
        )
      ),
      variableAndUnpredictableIncome: boolean(Joi).label(
        labeled(label, 'Variable and unpredictable income')
      ),
      recommendationProvidedBy: boolean(Joi).label(
        labeled(label, 'Recommendation provided by an independent financial advisor/accountant')
      ),
      taxationOrAccountingReasons: boolean(Joi).label(
        labeled(label, 'Taxation or accounting reasons (no tax advice is being given) ...')
      ),
      additionalComments: stringRequired(Joi, 1, 4096).label(
        labeled(label, 'Additional Details')
      ),
      other: boolean(Joi).label(labeled(label, 'Other'))
    })
    .orValue(
      'accommodateTemporaryReduction',
      'accommodateAnticipated',
      'variableAndUnpredictableIncome',
      'recommendationProvidedBy',
      'taxationOrAccountingReasons',
      'other'
    )
    .label(label)
    .when('.other', {
      is: true,
      then: Joi.object({
        otherComments: stringRequired(Joi, 1, 4096).label(labeled(label, 'Details'))
      })
    });

export default {
  schema
};
